import { render, staticRenderFns } from "./inbound-exception.vue?vue&type=template&id=82b8358a&"
import script from "./inbound-exception.vue?vue&type=script&lang=ts&"
export * from "./inbound-exception.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports